<template>
<button
  v-if="$can('events.download.documents') && event.status !== 1 && this.event.status !== 2"
  :disabled="loading"
  @click="handleDocumentsDownload()"
  class="btn btn-fill btn-wd btn-default btn-block btn-router"
>
  Download Documentação
</button>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import JSZip from 'jszip'
import Couchdb from 'src/services/Couchdb'
import { imageSuportService } from 'src/services/ImageSuport'
import downloadJs from 'downloadjs'

export default {
  name: 'BtnDownloadOldPresenter',

  data () {
    return {
      loading: false
    }
  },

  computed: {
    ...mapGetters('events', {
      event: 'event'
    }),

    ...mapGetters('tickets', {
      ticketsWinners: 'winners'
    }),

    ...mapGetters('customers', {
      customers: 'modelById'
    })
  },

  methods: {
    ...mapActions(['changeExecution']),

    handleDocumentsDownload () {
      this.changeExecution(true)
      this.loading = true
      this.zipperDocuments()
        .then(res => {
          console.log(res)
          this.loading = false
          this.changeExecution(false)
        })
        .catch(err => {
          console.log(err)
          this.loading = false
          this.changeExecution(false)
        })
    },

    async zipperDocuments () {
      let zip = new JSZip()
      for (let id in this.ticketsWinners) {
        let attachments = await Couchdb.connection('docs')
          .where('referenceId', this.ticketsWinners[id]._id)
          .all()

        let documents = []
        for (let file of attachments) {
          let anexo = false
          let name = null
          let value = null
          for (let index in file._attachments) {
            name = index
            anexo = await Couchdb.connection('docs').getAttachment(file._id, index)
            if (anexo.type === 'image/jpeg') {
              value = await imageSuportService.resizeImage(
                anexo,
                {
                  canvasId: 'canvasPlace',
                  maxWidth: 640,
                  maxHeight: 480,
                  maxQuality: 100
                }
              )
            } else {
              value = anexo
            }
            documents.push({
              name: name,
              value: value
            })
          }
        }
        let countImages = 0
        for (let file of documents) {
          let regex = /(?:\.([^.]+))?$/
          let ext = regex.exec(file.name)
          if (file.value.type === 'application/pdf') {
            let fileName = this.customers[this.ticketsWinners[id]].uc + ext[0]
            zip.file(fileName, file.value, 'application/pdf')
          } else {
            countImages += 1
            let fileName = this.customers[this.ticketsWinners[id]].uc + '_imagem_' + countImages + '_' + ext[0]
            zip.file(fileName, file.value.blob)
          }
        }
      }
      let data = this.$moment(this.event.endDate).format('DD_MM_YYYY')
      let zipName = this.event.city + '_' + data + '.zip'
      zip.generateAsync({ type: 'blob' })
        .then(blob => {
          downloadJs(blob, zipName)
        })
    }
  }
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/pages/Events/Actions/BtnDownloadDocumentation.vue